var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import Contact from 'edge/fnol/common/models/Contact';
import EntityUtil from 'gw-portals-util-js/EntityUtil';

var GeneralClaimExtension = function () {
    function GeneralClaimExtension(_claim, lob) {
        _classCallCheck(this, GeneralClaimExtension);

        Object.defineProperty(this, '_claim', {
            enumerable: false,
            value: _claim
        });

        var lobSection = this._claim.lobs[lob];
        this.fixedPropertyIncident = lobSection && lobSection.fixedPropertyIncident ? lobSection.fixedPropertyIncident : { propertyDescription: undefined };
        this.injuryIncidents = lobSection && lobSection.injuryIncidents ? lobSection.injuryIncidents : [];
    }

    _createClass(GeneralClaimExtension, [{
        key: 'addInjuryIncident',
        value: function addInjuryIncident() {
            var injured = new Contact({ tempID: EntityUtil.nextId() });

            this.injuryIncidents.push({
                tempID: EntityUtil.nextId(),
                description: null,
                injured: injured
            });
        }
    }, {
        key: 'removeInjuryIncident',
        value: function removeInjuryIncident(incidentToRemove) {
            var indexToRemove = this.injuryIncidents.findIndex(function (incident) {
                var tempIDMatches = incidentToRemove.tempID && incident.tempID === incidentToRemove.tempID;
                var publicIDMatches = incidentToRemove.publicID && incident.publicID === incidentToRemove.publicID;
                return tempIDMatches || publicIDMatches;
            });
            if (indexToRemove !== -1) {
                this.injuryIncidents.splice(indexToRemove, 1);
            }
        }
    }]);

    return GeneralClaimExtension;
}();

export default GeneralClaimExtension;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/general/models/GeneralClaimExtension.js
// module id = 1547
// module chunks = 0